
import { ref, defineComponent } from 'vue';

export default defineComponent({
  setup() {
    const serverHeaderTest = ref('');
    const cspTest = ref('');

    async function testCsp() {
      try {
        await fetch('https://www.example.org/index.html', { method: 'GET', mode: 'no-cors' });
        cspTest.value = 'fail';
      } catch {
        cspTest.value = 'ok';
      }
    }

    async function testServerHeader() {
      const response = await fetch('.', { method: 'GET' });
      serverHeaderTest.value = !response.headers.get('Server') ? 'ok' : 'fail';
    }


    return {
      serverHeaderTest,
      cspTest,
      testCsp,
      testServerHeader
    };
  }
});
